import {
  getList,
} from "@surya-digital/leo-ts-types";
import { GridAnswerElementV1, GridAnswerElementV1DTO, GridAnswerElementV1Enums } from "./gridAnswerElementV1";

export interface GridAnswerV1DTO {
  answers: GridAnswerElementV1DTO[];
}

export class GridAnswerV1 {
  readonly isGridAnswerV1GridAnswerV1: boolean = true;

  readonly answers: GridAnswerElementV1[];


  constructor(
  answers: GridAnswerElementV1[]
  ) {
    this.answers = answers;
  }

  static fromDTO(dto: GridAnswerV1DTO): GridAnswerV1 {
    const answers = getList<GridAnswerElementV1DTO, GridAnswerElementV1>(
      dto,
      "answers",
      GridAnswerElementV1.fromDTO,
      InvalidGridAnswerV1AnswersError
    );
    return new GridAnswerV1(
      answers
    );
  }

  toDTO(): GridAnswerV1DTO {
    const dto: GridAnswerV1DTO = {
        answers: this.answers.map((e: GridAnswerElementV1) => { return e.toDTO() })
    };
    return dto;
  }
  }

GridAnswerV1.prototype.toString = function toString(): string {
  return `GridAnswerV1(answers='${this.answers}')`;
};

export class InvalidGridAnswerV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridAnswerV1Error";
  }
}
export class InvalidGridAnswerV1AnswersError extends InvalidGridAnswerV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridAnswerV1AnswersError";
  }
}
